import Vue from 'vue'
import Router from 'vue-router'
import { routes as routes } from '../pages/index'
import store from '@/store'
import { getInstance as getAuth0PluginInstance } from '@/plugins/auth.js';
import { ToastProgrammatic as Toast } from 'buefy'
// import Cookies from '../helpers/cookies';
// import _ from 'lodash/lodash';

Vue.use(Router)
const router = new Router({
    mode: 'history',
    routes: routes
})
router.beforeEach((to, from, next) => {

    // @todo
    // store.dispatch('routeLoading');

	let auth0User;
    const Auth0Plugin = getAuth0PluginInstance();
	const routeIsPublic = (['auth.login'].indexOf(to.name) >= 0)
		? true
		: false;
	let accessGranted = routeIsPublic;	// until proven otherwise.
    const onAuth0Ready = () => {


		// NOTE: The final access decision is made in the .finally() block.
		store.commit('SET_LOADING',true);
		Auth0Plugin.getTokenSilently()
			.then(token => {
				if(!store.state.accessToken){
					store.commit('SET_ACCESS_TOKEN', token);
				}
				return Auth0Plugin.auth0Client.getUser();
			})
			.then(u => {
				auth0User = u;
				return Vue.$authService.getCurrent({ includes: 'permissions,roles' });
			})
			.then(user => {
				accessGranted = true;
				let auth = {
					roles: [],
					permissions: []
				};
				user.roles.forEach(role => {
					auth.roles.push(role.name);
				});
				user.permissions.forEach(permission => {
					auth.permissions.push(permission.name);
				});
				// Most of the user's details are stored at Auth0
				const mergedUser = Object.assign(
					{ id: user.id, sub: user.sub },
					{ email: user.email, name: user.name }
					// { email: auth0User.email, name: auth0User.name }
				);
				store.commit('SET_AUTH', auth);
				store.commit('SET_USER', mergedUser);
				return Promise.resolve(user);
			})
			.then(async ()=>{
				var notifications;
				await Vue.$authService.getNotifications().then((res)=> {
					notifications = res
				})
				store.commit('setNotifications',notifications)
			})
			.then(async ()=>{
				let referrer = document.referrer
				let uiUrl = process.env.VUE_APP_URL

				if(store.state.auth.roles.includes('user') || store.state.auth.roles.includes('gatekeeper')) {
					if(referrer.includes(uiUrl) && from.path==='/' && to.name==='tickets'){
						Auth0Plugin.logout({
							returnTo: `${window.location.origin}`
						});
					}
				}
				referrer = referrer.split('/')[0]+'//'+referrer.split('/')[2]
				if(referrer.length && !referrer.includes(uiUrl) && !store.state.isReferrerRegistered && referrer.split('/')[2]!=='undefined' && !referrer.includes('auth0')){
					await Vue.$appService.createApp({
						name: referrer,
						referrer:referrer
					}).then(async (response)=>{
						await Vue.$appService.attachUser(response)
					})
					store.commit('SET_REFERRER_REGISTRATION',true)
				}else if(!store.state.isReferrerRegistered){
					await Vue.$appService.appList().then(async (response)=>{
						store.commit('SET_APPS',response)
						if(!response.length){
							await Vue.$appService.attachUser()
							store.commit('SET_REFERRER_REGISTRATION',true)
						}
					})
				}
			})
			.catch(err => {
				// eslint-disable-next-line
				window.console && console.log(['[router][beforeEach]']);
				// eslint-disable-next-line
				window.console && console.log([err]);
			})
			.finally(() => {
				if (accessGranted) {
                    // @todo
					// store.dispatch('routeLoading', false);
					// let referrer = document.referrer
					// let link =_.find(store.getters.getApps,(value)=>{
					// 	return referrer.includes(value.href)
					// });
					// let roles = store.state.auth ? store.state.auth.roles : []

					if (to.name == 'auth.login') {
						if(from.name === "tickets"){
							router.go()
						}
						return next({ name: 'tickets' });
					}
					let roles = store.state.auth.roles
					if((!(roles.includes('serviceperson') || roles.includes('superadmin')) && to.name.includes('meetings'))) {
						Toast.open({
							type:'is-danger',
							message:`You have no access to: ${to.path}`
						})
						return next({ name: 'tickets' });
					}
					return next();
				}
				else {
					// We need to know the difference between needing to authenticate
					// and being authenticated but forbidden from accessing route.
					const permanent_failure = (store.state.accessToken && ! accessGranted)
						? true
						: false;

					if (permanent_failure) {
						// User was logged in but forbidden from accessing requested route.
						const nextLocation = null
						window.setTimeout(function() {
							if (nextLocation) {
                                // @todo
								// store.dispatch('routeLoading', false);
								return next(nextLocation);
							}
							else {
								Auth0Plugin.logout({
									returnTo: `${window.location.origin}`
								});
							}
						}, 2000);
					}
					else {
						// User simply not logged in so cannot access route.
						Auth0Plugin.loginWithRedirect({
							appState: { targetUrl: to.fullPath }
						});
						window.location.href = `https://${process.env.VUE_APP_AUTH0_DOMAIN}/logout`
					}
				}
			});
	}

	if ( ! Auth0Plugin.loading) {
		return onAuth0Ready();
	}
	else {
		const unwatch = Auth0Plugin.$watch("loading", loading => {
			if (loading === false) {
				unwatch();
				return onAuth0Ready();
			}
		});
	}
})

router.afterEach(() => {
	store.commit('SET_LOADING',false);
    store.commit("SET_ERRORS", null);
});

export default router